import { CoreIcon } from '../core-icon';
import bookmarkSVG from '../../assets/icons/bookmark.svg';
import type { IconProps } from '../core-icon';

export const BookmarkIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={bookmarkSVG} {...props} />;
};
